<template>
<div v-if="user">
  <div class="container text-left mt-5">
      <div class="row">
        <div class="col-lg-12">
          <b-tabs>
          <b-tab title="Details" active ref="detailsTab">
            <div class="row">
              <div class="col-lg-6">
                <div class="contact-info-section">
                  <h2 class="mt-4">User Information</h2>
                  <div><b>Name:</b> {{this.user.firstName}} {{this.user.lastName}}</div>
                  <div><b>Telephone:</b> {{this.user.telephone | telephoneNumber }}</div>
                  <div><b>Email:</b> {{this.user.email}}</div>
                  <div><b>Role:</b> {{this.user.role}}</div>
                  <div><b>Organizations:</b>
                    <div v-for="(org, index) in user.organizations" :key="index">
                      <li>{{org.name}}</li>
                    </div>
                  </div>
                  <td>
                    <router-link :to="{ name: 'users edit', params: { userId: userId } }" class="mt-3 btn btn-secondary event-link-btn">Edit</router-link>
                  </td>
                </div>
              </div>
            </div>
          </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: {
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        role: 'partner',
        organizations: [],
      },
    };
  },
  props: {
    userId: String,
  },
  async created() {
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_USERS_ROOT}/users/${this.userId}`);
      this.mapUser(response.data);
    } catch (err) {
      this.$bvToast.toast(('Error Loading User'), {
        title: 'Error',
        autoHideDelay: 5000,
        appendToast: false,
      });
    }
  },
  methods: {
    mapUser(usr) {
      this.user = {
        firstName: usr.first_name,
        lastName: usr.last_name,
        email: usr.email,
        telephone: usr.telephone,
        news: usr.tourism_news_optin,
        role: usr.role !== '' ? usr.role : 'partner',
        organizations: usr.organizations,
      };
      console.log(this.user.lastName);
    },
  },
};
</script>
